import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const initialState = {};

const middleware = [thunk];

const store = process.env.REACT_APP_RUNTIME === 'Development'
  ? createStore(
      rootReducer,
      initialState,
      compose(
        applyMiddleware(...middleware),
        typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION__
          ? window.__REDUX_DEVTOOLS_EXTENSION__()
          : f => f
      )
    )
  : createStore(
      rootReducer,
      initialState,
      compose(applyMiddleware(...middleware))
    );

export default store;
